// extracted by mini-css-extract-plugin
export default {"RevisionItem":"i8BNz","originalItem":"iHWBI","thumbnail":"P3wdZ","time":"umEO7","name":"ftoo8","note":"BcRVT"};